<template>
    <div class="vfb-field vfb-field--textarea" :class="classes.wrapper">
        <div class="vfb-field__container" :class="[classes.container, { 'has-value': hasValue }]">
            <FormLabel :id="id" :label="label" :required="required"
                       :className="classes.label"></FormLabel>

            <textarea class="vfb-textarea"
                      v-model="model"
                      :disabled="disabled" :required="required"
                      :placeholder="placeholder"
                      :rows="rows"
                      :name="name"
                      :aria-describedby="helpText ? id + '-help-block' : undefined"
                      :class="[classes.input, { 'has-value': hasValue}]"
                      :id="id">
            </textarea>

            <HelpText v-if="helpText" :helpText="helpText" :id="id + '-help-block'" :className="classes.help" />
        </div>

        <FormErrors class="vfb-errors" :class="classes.errors" />
    </div>
</template>

<script setup lang="ts">
import FormLabel from './Label.ce.vue'
import FormErrors from './Errors.ce.vue'
import HelpText from "./includes/HelpText.ce.vue";
import {computed} from "vue";

interface Classes {
    wrapper?: string;
    container?: string;
    input?: string;
    label?: string;
    help?: string;
    errors?: string;
}

interface Props {
    required?: boolean,
    disabled?: boolean,
    label: string,
    name: string,
    modelValue?: string,
    placeholder?: string,
    id: string,
    rows?: number,
    helpText?: string,
    classes?: Classes
}

let props = withDefaults(defineProps<Props>(), {
    rows: 6,
    disabled: false,
    required: false,
    placeholder: '',
    modelValue: '',
    helpText: '',
    label: '',
    classes: () => ({
        wrapper: 'js-form-validation__group',
        container: 'form-group',
        input: 'form-control',
        label: 'form-label',
        help: '',
        errors: '',
    }),
});

const emit = defineEmits<{
    (e: 'update:modelValue', value: string): void
}>();

const hasValue = computed(() =>
    (props.modelValue !== '' && props.modelValue != null) || props.placeholder.length > 0
)

const model = computed({
    get() {
        return props.modelValue;
    },
    set(value: string) {
        emit('update:modelValue', value);
    },
});
</script>
